<template>
  <generic-modal
    :title="$t('execution details')"
    ref="generic_modal"
    :is_wide="true"
  >
    <div>
      <div class="title is-5">{{ translate_status(meta.status_code) }}</div>
      <div class="subtitle is-6">{{ format_date_time(meta.create_date) }}</div>

      <div class="title is-6 pt-5">{{ $t("command") }}</div>
      <pre>{{ meta.command }}</pre>

      <div class="title is-6 pt-5 mb-2">{{ $t("arguments") }}</div>
      <pre>{{ meta.arguments }}</pre>

      <div class="title is-6 pt-5 mb-2">{{ $t("result") }}</div>
      <pre>{{ meta.result }}</pre>

      <!-- <pre>{{ meta }}</pre> -->
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  format_date_time,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "ExecutionLogModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {},
  methods: {
    format_date_time,
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(log_uuid) {
      let v = this;
      v.set_initial_state();
      get("/script/log", { uuid: log_uuid })
        .then((rspns) => {
          v.meta = rspns;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.error = "";
    },
    translate_status(status_code) {
      let v = this;
      switch (status_code) {
        case "N":
          return v.$t("new");
        case "R":
          return v.$t("running");
        case "F":
          return v.$t("finished");
        case "X":
          return v.$t("errored");
        default:
          return status_code;
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
